export default __webpack_public_path__ + "static/attestant-2ebc88b4664933b64e44012594764a1a.png";